import { render, staticRenderFns } from "./Saldos.vue?vue&type=template&id=6082ebcf&scoped=true&"
import script from "./Saldos.vue?vue&type=script&lang=js&"
export * from "./Saldos.vue?vue&type=script&lang=js&"
import style0 from "./Saldos.vue?vue&type=style&index=0&id=6082ebcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6082ebcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\MasterBranches\\Maintenance_06.04\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6082ebcf')) {
      api.createRecord('6082ebcf', component.options)
    } else {
      api.reload('6082ebcf', component.options)
    }
    module.hot.accept("./Saldos.vue?vue&type=template&id=6082ebcf&scoped=true&", function () {
      api.rerender('6082ebcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Materiais/Saldos.vue"
export default component.exports